import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/styles';
import {Grid} from '@material-ui/core';

import {
    Yesterday,
    TotalPoint,
    TotalDeals,
    RateByPlatform,
    GraphForLast30Days,
    TodayComment,
    TodayRanking
} from './components';

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(2)
    }
}));

const Dashboard = (props) => {
    const classes = useStyles();

    const {point = {}, deal = {}, rankings = [], platform = {}, trend = {}, comment = []} = props;

    return (
        <div className={classes.root}>
            <Grid
                container
                spacing={2}
            >
                <Grid
                    item
                    md={4}
                    sm={12}
                    xs={12}
                >
                    <Yesterday/>
                </Grid>
                <Grid
                    item
                    md={4}
                    sm={12}
                    xs={12}
                >
                    <TotalPoint data={point}/>
                </Grid>
                <Grid
                    item
                    md={4}
                    sm={12}
                    xs={12}
                >
                    <TotalDeals data={deal}/>
                </Grid>
                <Grid
                    item
                    lg={12}
                    md={12}
                    xl={12}
                    xs={12}
                >
                    <TodayRanking data={rankings}/>
                </Grid>
                <Grid
                    item
                    lg={4}
                    md={4}
                    xs={12}
                >
                    <RateByPlatform data={platform}/>
                </Grid>
                <Grid
                    item
                    lg={8}
                    md={8}
                    xs={12}
                >
                    <GraphForLast30Days data={trend}/>
                </Grid>
                <Grid
                    item
                    lg={12}
                    md={12}
                    xl={12}
                    xs={12}
                >
                    <TodayComment data={comment}/>
                </Grid>

            </Grid>
        </div>
    );
};

Dashboard.propTypes = {
    comment: PropTypes.object,
    deal: PropTypes.object,
    platform: PropTypes.object,
    point: PropTypes.object,
    rankings: PropTypes.arrayOf(PropTypes.object),
    trend: PropTypes.object
};

export default Dashboard;
